import script from "./EditUserNameModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserNameModal.vue?vue&type=script&setup=true&lang=js"

import "./EditUserNameModal.vue?vue&type=style&index=0&id=0cf313c6&lang=scss&scoped=true"
script.__scopeId = "data-v-0cf313c6"

export default script